import React from 'react';
import { motion } from 'framer-motion';

const ComicButton = ({ children, onClick, variant = 'primary', className = '' }) => {
  const variants = {
    primary: 'bg-comic-yellow text-black hover:bg-yellow-400',
    secondary: 'bg-comic-blue text-white hover:bg-blue-600',
    danger: 'bg-comic-red text-white hover:bg-red-600',
  };

  return (
    <motion.button
      whileHover={{ scale: 1.05, x: -2, y: -2, boxShadow: '8px 8px 0px 0px rgba(0,0,0,1)' }}
      whileTap={{ scale: 0.95, x: 0, y: 0, boxShadow: '0px 0px 0px 0px rgba(0,0,0,1)' }}
      onClick={onClick}
      className={`
        relative font-comic text-xl tracking-wider px-6 py-3 
        border-4 border-black shadow-comic transition-colors
        uppercase ${variants[variant]} ${className}
      `}
    >
      {children}
    </motion.button>
  );
};

export default ComicButton;